function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx("svg", _objectSpread({
        width: 24,
        height: 24,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props, {
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.455 10.4h1.965v5.251c0 5.018 4.735 5.657 7.178 5.657.834 0 1.4-.087 1.4-.087v-4.352s-.269.029-.686.029c-.983 0-2.74-.232-2.74-1.914v-4.5H24v-4h-3.427V2.191h-5.004v4.293h-2.114V10.4Zm-10.93 5.541s1.697 1.509 3.902 1.509c.774 0 1.518-.203 1.518-.696 0-.446-.835-.756-1.935-1.165-2.126-.79-5.242-1.948-5.242-5.16 0-2.814 2.77-4.554 6.314-4.554 3.573 0 5.39 1.711 5.39 1.711l-1.757 3.569s-1.489-1.22-3.633-1.22c-.774 0-1.52.204-1.52.726 0 .37.766.637 1.797.997 2.126.743 5.381 1.88 5.381 5.124 0 2.553-2.323 4.729-6.283 4.729-3.842 0-6.136-2.205-6.136-2.205l2.204-3.365Z",
            fill: "#2F4F92"
        })
    }));
};
export default Icon;
